import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable, forkJoin } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { IconeVo, RotaVo } from '~model/vo/rota-vo';
import { IconEventos, urlIconStatus } from '~utils/zindex-status-monitoramento';

@Injectable({
  providedIn: 'root',
})
export class IconService {

  constructor(
    private translate: TranslateService
  ) { }

  getTooltip(icone: IconeVo): Observable<string> {
    if (icone.toolTip) {
      return new BehaviorSubject<string>(icone.toolTip);
    }

    return forkJoin([
      this.translate.get('TIMELINE.ICONS').pipe(take(1)) as Observable<MapIcons>,
      this.translate.get('SHARED.TYPES').pipe(take(1)) as Observable<Record<string, string>>,
    ]).pipe(map(([mapIcons, mapTypes]) => {
      const mgs = [];
      const textOrg = icone.text ?? '';
      const evento = icone.evento || textOrg;
      const text = mapIcons[evento]?.TEXT ?? mapTypes[textOrg] ?? textOrg;
      // const sep = mapIcons[evento]?.SEP ?? ' - ';
      const sep = '\n';
      if (icone?.hour) {
        mgs.push(icone.hour);
      }
      if (text) {
        mgs.push(text);
      }
      return mgs.join(sep) ?? '';
    }));
  }

  prepareIcone(rotaVo: RotaVo, icone: IconeVo): Observable<IconeVo> {
    return this.getTooltip(icone).pipe(map(toolTip => {
      const matIcon = IconEventos[icone.evento ?? ''] ?? IconEventos[icone.grupo ?? ''];

      const imageIcon = icone.iconID !== undefined && icone.iconID >= 0
        && !['INICIOALMOCO', 'FIMALMOCO'].includes(icone.evento ?? '') && !matIcon
        ? `url(${urlIconStatus(icone, rotaVo.rotaCor || '')})` : undefined;
      return ({
        ...icone,
        matIcon,
        toolTip: icone.toolTip ? icone.toolTip : toolTip,
        imageIcon,
      });
    }));
  }
}

type MapIcons = {
  [type: string]: {
    TEXT?: string,
    SEP?: string
  }
};
